import React, { useState } from 'react';
import { Box, Text, VStack, Input, Button, Flex, useToast } from '@chakra-ui/react';
export function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const handleSubmit = () => {
    if (!email || !email.includes('@')) {
      toast({
        title: 'Please enter a valid email 💕',
        status: 'error',
        duration: 3000,
        isClosable: true
      });
      return;
    }
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setEmail('');
      toast({
        title: 'Welcome to the family! 💕',
        description: "You're officially part of the Love & xx's sisterhood.",
        status: 'success',
        duration: 4000,
        isClosable: true
      });
    }, 1000);
  };
  return <Box as="section" bg="#FAE0E4" py={{
    base: 16,
    md: 20
  }} px={{
    base: 6,
    md: 12
  }} position="relative" overflow="hidden" data-id="element-155">
      {/* Pinstripe overlay */}
      <Box position="absolute" inset={0} className="pinstripe-bg" opacity={0.5} pointerEvents="none" data-id="element-156" />

      <VStack spacing={6} maxW="600px" mx="auto" textAlign="center" position="relative" zIndex={1} data-id="element-157">
        {/* Script accent */}
        <Text className="font-script" fontSize={{
        base: '22px',
        md: '26px'
      }} color="#C9929D" data-id="element-158">
          stay in the loop
        </Text>

        {/* Headline */}
        <Text as="h2" className="font-serif" fontSize={{
        base: '24px',
        md: '30px'
      }} fontWeight={700} color="#3A3A3A" lineHeight={1.3} data-id="element-159">
          Join the Love & xx's Family 💕
        </Text>

        {/* Subtext */}
        <Text className="font-body" fontSize={{
        base: '15px',
        md: '16px'
      }} color="#3A3A3A" lineHeight={1.7} maxW="480px" opacity={0.85} data-id="element-160">
          Be the first to know about new drops, exclusive bundles, pop-up
          events, and a little encouragement in your inbox.
        </Text>

        {/* Email form */}
        <Flex direction={{
        base: 'column',
        sm: 'row'
      }} gap={3} w="100%" maxW="480px" data-id="element-161">
          <Input type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} bg="white" border="1.5px solid" borderColor="rgba(201,146,157,0.3)" borderRadius="24px" h="52px" px={5} fontSize="15px" className="font-body" color="#3A3A3A" _placeholder={{
          color: 'gray.400'
        }} _focus={{
          borderColor: '#C9929D',
          boxShadow: '0 0 0 2px rgba(201,146,157,0.2)'
        }} flex={1} onKeyDown={e => e.key === 'Enter' && handleSubmit()} data-id="element-162" />
          <Button bg="#C9929D" color="white" fontSize="15px" fontWeight={600} px={7} h="52px" borderRadius="24px" className="font-body" _hover={{
          bg: '#b8818c',
          transform: 'translateY(-1px)'
        }} _active={{
          bg: '#a87080'
        }} transition="all 0.2s" onClick={handleSubmit} isLoading={isLoading} loadingText="Signing up..." whiteSpace="nowrap" w={{
          base: '100%',
          sm: 'auto'
        }} data-id="element-163">
            Sign Up 💕
          </Button>
        </Flex>

        {/* Fine print */}
        <Text className="font-body" fontSize="12px" color="#3A3A3A" opacity={0.6} data-id="element-164">
          No spam, ever. Just love, drops, and encouragement. 💕
        </Text>
      </VStack>
    </Box>;
}